<template>
  <div>
    <!-- header section -->
    <section class="banner" role="banner">
      <header id="header">
        <div class="header-content clearfix">
          <!-- ロゴ -->
          <a class="logo" href>
            <div class="c-logo">
              <img class="cara-img" src="../../assets/images/cara-002.svg" alt="きっずてぃーしんくのキッズキャラ">
              <div class="c-logo-side">
                <img
                  class="logo-img"
                  src="../../assets/images/logo-kidstthink.svg"
                  alt="無料のT字型思考法アプリ きっずてぃーしんく"
                >
                <span class="logo-soeji">きっずてぃーしんく</span>
                <span class="logo-setumei">T字型思考法アプリ</span>
              </div>
            </div>
          </a>

          <!-- navigation section  -->
          <nav class="navigation" role="navigation">
            <ul class="primary-nav">
              <li>
                <div class="menu-button login" @click="ToLoginPage()">ログイン</div>
              </li>
              <li>
                <div class="menu-button signup" @click="ToSignupPage()">アカウントをつくる（無料）</div>
              </li>
              <li>
                <div class="menu-button trial" @click="ToTrial()">やってみる（無料）</div>
              </li>
            </ul>
          </nav>
          <a href="#" class="nav-toggle">
            Menu
            <span></span>
          </a>
        </div>
        <!-- navigation section  -->
      </header>
      <!-- banner text section-->
      <div id="banner" class="container">
        <div class="col-md-5 col-sm-12">
          <!-- <img
                    class="banner-img img-responsive"
                    src="../../assets/style/landing/images/app-screen.png"
          >-->
          <img
            class="banner-img img-responsive"
            src="../../assets/images/top-001.svg"
            alt="トップイメージ"
          >
        </div>
        <div class="col-md-7 col-sm-12">
          <div class="banner-text">
            <p class="upper-text">すごい<ruby><rb>考</rb><rt>かんが</rt></ruby>えがどんどん生まれる！
              <ruby>
                <rb>魔法</rb>
                <rt>まほう</rt>
              </ruby>
              の
              <ruby>
                <rb>思考法</rb>
                <rt>しこうほう</rt>
              </ruby></p>
            <!-- <p class="upper-text">最新の「<ruby>
                <rb>T字型思考法</rb>
                <rt>ティーじがたしこうほう</rt>
              </ruby>」を手軽にはじめてみませんか？</p> -->
            <h1>
              <!-- copy1 -->
              <!-- <ruby><rb>考</rb><rt>かんが</rt></ruby>えるのが<ruby><rb>苦手</rb><rt>にがて</rt></ruby>な<ruby><rb>人</rb><rt>ひと</rt></ruby>がぐんぐん<ruby><rb>成長</rb><rt>せいちょう</rt></ruby>する<ruby><rb>方法</rb><rt>ほうほう</rt></ruby>！ -->

              <!-- copy2 -->
              <span class="highlight">
              <ruby>
                <rb>考</rb>
                <rt>かんが</rt>
              </ruby>える
              <ruby>
                <rb>力</rb>
                <rt>ちから</rt>
              </ruby></span>がつく
              <ruby>
                <rb>新</rb>
                <rt>あたら</rt>
              </ruby>しい
              <ruby>
                <rb>習慣</rb>
                <rt>しゅうかん</rt>
              </ruby>
。
              <!-- <ruby>
                <rb>伝</rb>
                <rt>つた</rt>
              </ruby>えたい
              <ruby>
                <rb>言葉</rb>
                <rt>ことば</rt>
              </ruby>をみつけられる
              <ruby>
                <rb>魔法</rb>
                <rt>まほう</rt>
              </ruby>-->
              <span style="display: inline-block;">
                <span class="banner-text-logo">
                  <img
                    class="logo"
                    src="../../assets/images/logo-kidstthink.svg"
                    　alt="キッズティーシンクのロゴ"
                  >
                  <img
                    class="logo-yomi"
                    src="../../assets/images/txt-logosoeji.svg"
                    　alt="キッズティーシンク"
                  >
                </span>
              </span>ではじめよう！
            </h1>
            <p class="sentence">
              子供から大人まで考える力がぐんぐんのびる！自分の気持ちをすらすら言葉にできる！
             今すぐ
              
              <ruby>
                <rb>T字型思考法</rb>
                <rt>ティーじがたしこうほう</rt>
              </ruby>をはじめよう！
            </p>
            <div class="banner-btn">
              <!-- やってみるボタン -->
              <div class="t-button" @click="ToTrial()">
                <i class="fas fa-play-circle"></i>
                さぁ、やってみよう！（無料）
                <!-- <ruby>
                  <rb>使</rb>
                  <rt>つか</rt>
                </ruby> -->

                <div class="eigi">おためしで使って、あとで登録もできます</div>
              </div>

              <br>
              <div class="btn-login" @click="ToLoginPage()">
                <i class="fas fa-chevron-right"></i>ログインはこちら
              </div>
            </div>
          </div>
          <!-- banner text section-->
        </div>
      </div>
    </section>
    <!-- header section -->

    
    
    <!-- overview section -->
    <section id="overview" class="section overview">
      <div class="container">

        <div class="row" >

            <div class="col-md-8 col-md-offset-2 text-center" style="margin-top:20px;margin-bottom:90px;">
                <p class="what">
                  <span class="highlight">きっずてぃーしんく</span>とは？
                </p>

                <p class="what-text">
                  手軽に「T字型思考法」を実践できるWEBアプリです。<br />
                  おためしで登録作業なしですぐに「T字型思考法」をはじめられます。<br />
                  ボランティアとして作成されているので、完全無料でご利用いただけます。<br />
                  学習、プレゼン、作文づくり、自分探しにご活用していただければ幸いです。<br />
                </p>

            </div>
          </div>

        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="section-title">
            
              <span class="highlight">
                
              <ruby>
                <rb>一歩</rb>
                <rt>いっぽ</rt>
              </ruby></span>ふみこんだ
              <span class="highlight">
              <ruby>
                <rb>思考力</rb>
                <rt>しこうりょく</rt>
              </ruby></span>を
             身につける
              <!-- <ruby>
                <rb>自分</rb>
                <rt>じぶん</rt>
              </ruby>をみつけるは、こどものうちから-->
              <span>
                <img class="logo" src="../../assets/images/logo-kidstthink.svg">
              </span>
            </h2>
            <p class="howtouse"><img class="fukidasi" src="../../assets/images/fukidasi-3fundewakaru.svg">
             <ruby><rb>使い方</rb><rt>つかいかた</rt></ruby>の
             <span class="highlight">
            <ruby><rb>紹介</rb><rt>しょうかい</rt></ruby>
            ムービー</span></p>

             
          </div>

          <!-- 紹介動画 -->
          <div class="col-md-12 text-center overview-video">
            <div class="movie-wrap">
              <iframe
                src="https://www.youtube.com/embed/CDVtEmegkqo"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-12" >
            
            <span class="icon icon-browser"></span>
            <img
              class="overview-img"
              src="../../assets/images/txt-000-kangaeta.svg"
              　　alt="手順1.考えた"
            >
            <div class="overview-content">
              <h4>１．Let's Start</h4>
              <!-- <p class="sentence">テーマを考えよう！なんでもいいよ！</p> -->
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <span class="icon icon-trophy"></span>
            <img class="overview-img" src="../../assets/images/txt-002-kanjita.svg" 　alt="手順2.感じた">
            <div class="overview-content">
              <h4>2.How Do you Feel?</h4>
              <!-- <p class="sentence">テーマのことについてしばらく考えてみよう。なにか感じるかな？</p> -->
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <span class="icon icon-lifesaver"></span>
            <img
              class="overview-img"
              src="../../assets/images/txt-003-kakubesi.svg"
              　alt="手順1.書くべし"
            >
            <div class="overview-content">
              <h4>Write</h4>
              <!-- <p class="sentence">感じた言葉を次々と書こう！大切なのは、どんな浮かんできたものはすべて書くことだよ</p> -->
            </div>
          </div>
        <div class="row" >

          <div class="col-md-8 col-md-offset-2 text-center" style="margin-top:60px;">
          
           
            <p class="what">
              <span class="highlight"><ruby><rb>T字型思考法</rb><rt>てぃーじがたしこうほう</rt></ruby></span>とは？
            </p>

            <p class="what-text">
              
              「<ruby>
                <rb>T字型思考法</rb>
                <rt>ティーじがたしこうほう</rt>
              </ruby>」は
              テーマについて感じたことを記入しながら、自分にとって大切な言葉や気持ちに気づける思考法です。<br />
              人気
              コピーライター梅田悟司さんの著書"「言葉にできる」は武器になる。"の中で
              提唱されている思考フレームワークです。<br />
              実践前に、梅田さんの著書「言葉にできるは武器になる」、「気持ちを「言葉にできる」魔法のノート」の２冊を読まれることをおすすめ致します。
              
            </p>

             
          </div>


           <!-- <div class="col-md-8 col-md-offset-2 text-center">
          
           
            <p class="howtouse">
             
               この <ruby><rb>名著</rb><rt>めいちょ</rt></ruby>を<ruby><rb>手</rb><rt>て</rt></ruby>に<ruby><rb>入</rb><rt>い</rt></ruby>れよう！
            </p>

             <p >
              ※画像をクリックすると別タブで<ruby><rb>Amazon</rb><rt>アマゾン</rt></ruby>に移動します。ぜひご購入ください。
            </p>

            <p class="book-section">
              
　　　　　　　　　<a target="_blank"  href="https://www.amazon.co.jp/gp/product/453232212X/ref=as_li_tl?ie=UTF8&camp=247&creative=1211&creativeASIN=453232212X&linkCode=as2&tag=kidstthink-22&linkId=dcfb8312d042b11f89b9fd3ffb459932"><img border="0" src="//ws-fe.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=JP&ASIN=453232212X&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=kidstthink-22" ></a><img src="//ir-jp.amazon-adsystem.com/e/ir?t=kidstthink-22&l=am2&o=9&a=453232212X" width="1" height="1" border="0" alt="" style="border:none !important; margin:0px !important;" />


　　　　　　　　　　<a target="_blank"  href="https://www.amazon.co.jp/gp/product/4532320755/ref=as_li_tl?ie=UTF8&camp=247&creative=1211&creativeASIN=4532320755&linkCode=as2&tag=kidstthink-22&linkId=17dedba21ab6509d3e0c5c8a15b574b0"><img border="0" src="//ws-fe.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=JP&ASIN=4532320755&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=kidstthink-22" ></a><img src="//ir-jp.amazon-adsystem.com/e/ir?t=kidstthink-22&l=am2&o=9&a=4532320755" width="1" height="1" border="0" alt="" style="border:none !important; margin:0px !important;" />
            </p>

             
          </div> -->


          


        </div>
      </div>
    </section>
    <!-- overview section -->

     <!-- feature section 1 -->
    <section id="features" class="section features1">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
             <img class="features-top-img" src="../../assets/images/logo-moji-kidstthink.svg" style="margin-bottom:40px;" 　alt="ロゴ">
            <h2 class="section-title">
           
               <span class="highlight">
              <ruby>
                <rb>自分</rb>
                <rt>じぶん</rt>
              </ruby>の気持ち
               </span>がぐんぐん見えてくる！
              <!-- <br />どなた様もぜひご
              <ruby>
                <rb>利用</rb>
                <rt>りよう</rt>
              </ruby>ください！ -->
              <!-- <span>考えるツール</span> -->
            </h2>
            <p class="section-intro sentence">
               <ul class="good-list">
                <li class="title">こんなときにおすすめ!</li>
                <li>
                  <i class="far fa-check-square"></i> 
                本当の自分の気持ちを確認したいときに！
                </li>
                <li>
                  <i class="far fa-check-square"></i> 
                 考えるのが苦手を克服したいときに！
                </li>
                 <li>
                 <i class="far fa-check-square"></i>
                考える力をつけたいときに！
                </li>
                <li>
                 <i class="far fa-check-square"></i>
                 作文づくりに悩んでいるときに！
                </li>
                <li>
                 <i class="far fa-check-square"></i>
               自分の気持ちを伝えられるようになりたいときに！
                </li>
                 <li>
                 <i class="far fa-check-square"></i> 考え事を整理してスッキリしたいときに
                </li>
                <li>
                  <i class="far fa-check-square"></i>
                  はじめてT字型思考法をやってみたいときに!
                </li>
                <li>
                  <i class="far fa-check-square"></i> 
                  自分らしさを発見したいときに！
                </li>

                <li class="title" style="color:#42b983;line-height:1.8;">
                  きっずてぃーしんくで「<ruby>
                <rb>T字型思考法</rb>
                <rt>ティーじがたしこうほう</rt>
              </ruby>」をやってみてください！</li>
              </ul>
            </p>
          </div>
        </div>
        <div class="row features1-content-space">
          <div class="col-md-4 col-sm-12">
            <div class="features1-content left">
              <span class="icon icon-upload">
                <img class="overview-img" src="../../assets/images/illust-002-think.svg" alt="イラスト">
              </span>
              <h4>子どもの
                <ruby>
                <rb>思考力</rb>
                <rt>しこうりょく</rt>
              </ruby>
                を伸ばすために簡単にできることはないかな？</h4>
              <!-- <p class="sentence">
                なにかを経験して、心に浮かんでくることを言葉にする。
                それが「考える」ことの一歩。
                テーマに対して心に浮かんだ言葉をひとつひとつ書き出しいく「T字型思考法」を行って
                子供の思考力を自然と伸ばしていくことができます。
              </p> -->
            </div>
          </div>
          <div class="col-md-4 col-sm-12 middle">
            <!-- <img class="img-responsive" src="../../assets/style/landing/images/feature-mobile.png"> -->
            <img class="img-responsive" src="../../assets/images/pc-screen-001.png" alt="PCイメージ">
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="features1-content right">
              <span class="icon icon-speedometer">
                <img class="overview-img" src="../../assets/images/cara-nezumi.svg" alt="イラスト">
              </span>
              <h4>話すのは
                <ruby>
                <rb>苦手</rb>
                <rt>にがて</rt>
              </ruby>
                。けど自分らしく話せるようになりたい
                。</h4>
              <!-- <p class="sentence">
                自分のことを話そうとすると何を話していいか真っ白になりませんか？
                とっても簡単に自分の「考え」を育てる練習方法があるんです。それが「T字型思考法」です。
              </p> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- feature section 1 -->
    
   
    <!-- feature section 2 -->
    <section id="features" class="section features2">
      <div class="container">
        <div class="row">
          <div class="col-md-6" style="float:right;">
            <div class="features2-content">
              <h2 class="section-title">
                 <span class="highlight">
                <ruby>
                  <rb>教育</rb>
                  <rt>きょういく</rt>
                </ruby>
                </span>
                で
                取り入れたい
                あなたにオススメです。
                <!-- <ruby>
                  <rb>活用</rb>
                  <rt>かつよう</rt>
                </ruby>いただけます！ -->
              </h2>
              <p class="description">子供の「考える」力を伸ばす授業に、ぜひ取り入れてください。</p>
              <ul class="checklist">
                <li class="title">「実習： T字型思考法を活用した作文づくり」</li>
                <li>
                  <i class="fa fa-check"></i> パソコンを使う授業の一環としておこなおう！
                </li>
                <li>
                  <i class="fa fa-check"></i>１つのテーマをT字型思考法で考えてもらおう！
                </li>
                <li>
                  <i class="fa fa-check"></i> 考えた内容をもとに作文を作ってもらおう！
                </li>
                <li>
                  <i class="fa fa-check"></i> T字型思考法でつくってみてどうだったか話してみよう！
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6">
            <!-- <img class="img-responsive" src="../../assets/style/landing/images/feature-screen2.png"> -->
            <img class="img-responsive" src="../../assets/images/pc-screen-001.png" alt="PCイメージ">
          </div>
        </div>
      </div>
    </section>
    <!-- feature section 2 -->
    <!-- feature section 3 -->
    <section id="features" class="section features3">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="features2-content">
              <h2 class="section-title">
                もっとも<ruby>
                  <rb>手軽</rb>
                  <rt>てがる</rt>
                </ruby>に始められます！<br />
                 <span class="highlight">
                <ruby>
                  <rb>出張</rb>
                  <rt>しゅっちょう</rt>
                </ruby>レクチャー</span>をご
                <ruby>
                  <rb>活用</rb>
                  <rt>かつよう</rt>
                </ruby>ください。
              </h2>
              <p
                class="sentence"
              >はじめるまでの学習や準備が面倒ですか？それなら出張レクチャーをご利用下さい。有料で使い方、設定、T字型思考のやり方をお教えします！導入前の最初の一歩にご利用ください！</p>
              <p></p>
            </div>
          </div>
          <div class="col-md-6">
            <img style="width:200px;f" src="../../assets/images/cara-nezumi-3.svg" alt="PCイメージ">
          </div>
        </div>
      </div>
    </section>

    <!--subscribe section -->
    <section id="download" class="section subscribe bg-yellow">
      <!-- <div class="overlay"></div> -->
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="sentence">
               <span class="highlight">
              <ruby>
                  <rb>無料</rb>
                  <rt>むりょう</rt>
                </ruby></span>アカウントをつくろう！
            </h2>
            <p class="sentence">「きっずてぃーしんく」はボランティアとして作成された、完全無料のWEBアプリです。</p>

            <!-- やってみるボタン -->
            <!-- <div class="t-button" @click="ToTrial()">
              <i class="fas fa-play-circle"></i>
              さぁ、やってみよう！
              <div class="eigi">おためしで使って、あとで登録もできます</div>
            </div> -->


            <!-- サインアップボタン -->
            <div @click="ToSignupPage()" class="t-button">
              <i class="fas fa-play-circle"></i>
               <ruby>
                <rb>今</rb>
                <rt>いま</rt>
              </ruby>すぐアカウントをつくる
              <!-- <ruby>
                <rb>無料登録</rb>
                <rt>むりょうとうろく</rt>
              </ruby>してはじめよう！ -->
              <div class="eigi">メールアドレスで無料でご利用できます</div>
            </div>
          </div>
        </div>
      </div>
    </section>


 <section  class="section bg-white">
      <div class="container">
        <!-- <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="sentence">
               <span class="highlight">
                 ご要望はこちらから
             </span>
            </h2>
             <p class="sentence">みなさんの要望が届き、もっと使いやすいアプリに育っていきます。</p>
          </div>
        </div>
    <iframe frameborder="0"  width="100%" height="530px;" src="https://ishimaru-app.com/kidstthink-contact/" >
    </iframe> -->

     <p class="section-intro sentence">
               <ul class="good-list">
                <li class="title">もしKidsTThinkがうまく動かない時、お試しください</li>
                <li>
                  <i class="far fa-check-square"></i> 
                ページをリロード（再読み込み）してみてください。
                </li>
                 <li>
                  <i class="far fa-check-square"></i> 
               Google「Chrome」を使って動くか試してみてください。
                </li>
               
              </ul>
            </p>

     <!-- <p class="section-intro sentence">
               <ul class="good-list">
                <li class="title">修正一覧</li>
                <li>
                  <i class="far fa-check-square"></i>
                2020.06---調査中：やってみるボタンが動かないとの報告ありがとうございます。現在調査中です。
                </li>
                 <li>
                  <i class="far fa-check-square"></i>
                2020.05---メールアドレスでアカウント登録後メインページに移動しない不具合を修正しました。
                </li>
                <li>
                  <i class="far fa-check-square"></i>
                2020.04---やってみるボタンが動かない不具合を修正しました。
                </li>
                <li>
                  <i class="far fa-check-square"></i>
                 2020.04---やってみるボタンが動かないとの報告ありがとうございます。（済）
                </li>
              </ul>
            </p> -->
      </div>


    </section>

    <!-- footer section-->
    <footer class="section footer">
      <div class="footer-bottom">
        <div class="container">
          <div class="col-md-12">
            <p>開発・運営: IshimaruApp  <span class="contact-link">お問い合わせ</span></p>
          </div>
        </div>
        <div class="container">
          <div class="col-md-12">
            <p>© Copyright © 2019 KidsTThink. All Rights Reserved. Made with ISHIMARU APP.</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>



<script>
export default {
  name: "LandingPage",

  methods: {
    ToSignupPage() {
      //ページ遷移
      this.$router.push({ name: "SignUp" });
    },
    ToLoginPage() {
      //ページ遷移
      this.$router.push({ name: "login-home" });
    },
    ToTrial() {
      this.$router.push({ name: "login-home", params: { trial: true } });
    }
  },
  beforeCreate: function() {
    document.body.className = "landing";
  },
  beforeDestroy() {
    document.body.className = "";
  }
};
</script>
<style scoped src="../../assets/style/landing/css/bootstrap.min.css">
</style>
<style scoped src="../../assets/style/landing/css/main.css">
</style>

<style scoped lang="scss">
@import "../../assets/style/common.scss";
#header {
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 15px;
  padding-bottom: 10px;
  background: rgba(66, 185, 131, 0.9);

  @include mq-down(md2) {
    padding: 10px 10px 0px 10px;
  }
}

.footer {
}

h1 {
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #573f23;
  text-shadow: 1px 2px 0px #573f23;

  .highlight {
    color: rgb(241, 241, 146);
    font-weight: 900;
  }
}
.description {
  color: #573f23;
  font-size: 1em !important;
  font-weight: 400 !important;
}

.checklist {
  li {
    font-weight: 600;
    color: white;
    margin-bottom: 15px;
    margin-left: 15px;
  }
  .title {
    font-weight: bold;
    color: white;
    font-size: 1.2em;
    margin-left: 0;
  }

  li > i {
    margin-right: 10px;
    color: white;
    color: #ffcc66;
  }
}

.section {
  padding-top: 90px;
  padding-bottom: 70px;
  color: #573f23;
}

.features2-content {
  margin-top: 0;
}
.overview {
  background: #f6e8cc;
}

h2.sentence {
  font-weight: 600 !important;
  /* font-size:16px!important; */
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #573f23;
  text-shadow: 1px 2px 0px #573f23;

  .highlight {
    color: rgb(241, 241, 146);
    font-weight: 900;
  }
}

p.sentence {
  font-weight: 600 !important;
  color: #573f23;
}

.banner-text-logo {
  position: relative;
  /* display:flex;
      flex-direction: column;
      align-items: center; */
}

.book-section {
  & > a {
    margin-right: 20px;
  }
}
//-------------------------
//
.what {
  font-size: 1.8em;
  font-weight: 900;
  letter-spacing: 0.18em;
  margin-bottom: 50px;
  position: relative;

  color: white;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #573f23;
  text-shadow: 1px 2px 0px #573f23;

  .highlight {
    color: rgb(241, 241, 146);
    font-weight: 900;
  }
}
.what-text {
  font-size: 1em;
  font-weight: 600;
  //letter-spacing: 0.18em;
  line-height: 2;
  text-align: left;
  color: #573f23;
}

.howtouse {
  font-size: 1.8em;
  font-weight: 900;
  letter-spacing: 0.18em;
  margin-top: 80px;
  margin-bottom: 50px;
  position: relative;

  color: white;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #573f23;
  text-shadow: 1px 2px 0px #573f23;

  ruby > rt {
    color: #573f23;
    -webkit-text-stroke-width: 0px;
    text-shadow: none;
    font-size: 10px;
  }

  .highlight {
    color: rgb(241, 241, 146);
    font-weight: 900;
  }

  .fukidasi {
    position: absolute;
    top: -90px;
    left: -20px;
    @include mq-down(md2) {
      width: 100px;
      top: -50px;
      left: 0px;
    }
  }
}

/* --------------
    紹介動画:レスポンシブ対応
    -------------- */
.movie-wrap {
  position: relative;
  padding-bottom: 56.25%; /*アスペクト比 16:9の場合の縦幅*/
  height: 0;
  overflow: hidden;

  & iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.logo-yomi {
  position: absolute;
  bottom: -35px;
  width: 50%;
  left: 100px;
}

/* --------------
    ロゴ
    -------------- */
.c-logo {
  margin-right: 5px;
  margin-left: 5px;
  display: flex;
  align-items: start;

  //ロゴSVG
  .logo-img {
    @include mq-down(md2) {
      width: 160px;
    }
  }

  //キャラ
  .cara-img {
    width: 70px;
    @include mq-down(md2) {
      display: none;
    }
  }
}

.c-logo-side {
  // width: 230px;
  display: flex;
  flex-direction: column;
  @include mq-down(md2) {
    // width: 210px;
  }
}

span.logo-soeji {
  color: white;
  margin-top: 3px;
  margin-left: 20px;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.6em;

  @include mq-down(md2) {
    display: none;
  }
}
span.logo-setumei {
  color: #573f23;
  margin-top: -105px;
  margin-left: 20px;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.6em;
  @include mq-down(md2) {
    display: none;
  }
}

.banner-text {
  padding-bottom: 50px;
}

/* --------------
     キャッチ内のロゴ
    -------------- */
.banner-text .logo {
  width: 270px;
  margin-right: 5px;
  margin-left: 5px;
}

p.upper-text {
  font-weight: 900;
  font-size: 22px;
  color: #573f23;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #fff;
  margin-bottom: 0;
}

/* --------------
     メニューボタン：
    -------------- */
.menu-button {
  cursor: pointer;

  border-radius: 16px;
  display: inline-block;
  font-size: 16px;
  line-height: 1.1em;
  margin: 0 5px;
  padding: 10px 25px;
  text-decoration: none;
  vertical-align: top;
  font-weight: 600;
  transition: all 200ms 0s ease;

  @include mq-down(md2) {
    padding: 10px 10px;
    font-size: 0.8em;
    margin: 0 2px;
  }

  &.login {
    background-color: #e2e4e6;
    box-shadow: 0 2px 0 rgb(158, 159, 160);
    color: #573f23;
  }

  &.signup {
    background-color: #ffcc66;
    box-shadow: 0 2px 0 #573f23;
    color: #573f23;
    @include mq-down(sm2) {
      display: none;
    }
    &:hover {
      background: rgb(250, 171, 13);
    }
  }

  &.trial {
    background-color: #228659;
    box-shadow: 0 2px 0 #135537;
    color: #ffffff;
    &:hover {
      background: #166843;
    }
  }

  &.login:hover {
    background-color: rgb(238, 240, 241);
  }
}

.t-button {
  cursor: pointer;
  color: #fff;
  margin-top: 30px;
  display: block;
  border: none;
  background: #228659;
  text-align: center;
  border-radius: 35px;
  padding-top: 20px;
  padding-bottom: 10px;

  vertical-align: middle;
  letter-spacing: 0.03em;
  font-weight: 600;
  font-size: 22px;
  transition: all 200ms 0s ease;

  box-shadow: 0px 4px #135537;

  @include mq-down(md2) {
    border-radius: 30px;
    font-size: 16px;
    padding-top: 15px;
  }
}

rt {
  transform: scale(0.9);
  letter-spacing: 0.04em;
}

.t-button > .eigi {
  font-size: 16px;
  font-weight: normal;
  margin-top: 2px;
  margin-bottom: 4px;
  @include mq-down(md2) {
    font-size: 14px;
    margin-top: 8px;
  }
}

.t-button:hover {
  background: #166843;
}

.t-button > i {
  margin-right: 5px;
  font-size: 16px;
  font-weight: normal;
}

.btn-login {
  margin-left: 20px;
  color: #fff;
  margin-top: 20px;
  font-size: 22px;
  cursor: pointer;
}

.btn-login > i {
  margin-right: 10px;
}

.btn-login:hover {
  opacity: 0.8;
}

.section-title {
  letter-spacing: 0;
  color: white;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #573f23;
  text-shadow: 1px 2px 0px #573f23;
  line-height: 1.8;

  .highlight {
    color: rgb(241, 241, 146);
    font-weight: 900;
  }

  & > ruby > rt {
    color: #573f23;
    -webkit-text-stroke-width: 0px;
    text-shadow: none;
    font-size: 10px;
  }
}

.good-list {
  text-align: left;
  color: #573f23;

  li {
    font-weight: 600;
    font-size: 1.2em;
    margin-bottom: 25px;
    margin-left: 15px;
  }

  .title {
    font-weight: 900;
    letter-spacing: 0;
    font-size: 1.4em;
    margin-left: 0;
    margin-bottom: 30px;
  }

  li > i {
    margin-right: 10px;
    font-size: 1.2em;
    color: #228659;
  }
}

.contact-link {
  display: inline-block;
  margin-left: 10px;
  cursor: pointer;

  &:hover {
    color: #ff6600;
  }
}

.bg-yellow {
  background: #ffcc66 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/LandingPage.vue